import { useState } from "react";
import { NavLink } from "react-router-dom";

import {
	check_one_bend_bay,
	Render_measurtement,
	Toggle_measurtement_type,
	Render_summary,
	Render_status,
	Render_save_overlay,
} from "../js/bay-checker.js";

export default function One_bend() {
	const [update, force_update] = useState(0);

	const [measurtement_ab, set_measurtement_ab] = useState("");
	const [measurtement_bc, set_measurtement_bc] = useState("");
	const [measurtement_ac, set_measurtement_ac] = useState("");

	let does_it_work = check_one_bend_bay(measurtement_ac, measurtement_ab, measurtement_bc);
	let the_summary = "(empty)";

	return (
		<div className="bay max_width">
			<div className="top">
				<div className="header">
					<NavLink className="back_to_home" to="/app/bay-checker/"></NavLink>
					<h2>
						<strong>One bend</strong> bay
					</h2>
				</div>

				<div className="svg_wrap">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 330 150">
						<path
							stroke="#7BAABD"
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="8"
							d="M52.7 142.7 165.5 30l112.7 112.7"
						/>
						<path
							fill="#D4D0C4"
							d="m165.5 41.1 3.1 3.2a1.5 1.5 0 0 1-2.1 2.1l-1-1-1 1a1.5 1.5 0 0 1-2.1-2.1l3-3.2Zm-5.2 7.3c.6.6.6 1.6 0 2.1l-4.1 4.2a1.5 1.5 0 1 1-2.1-2.1l4.1-4.2c.6-.6 1.6-.6 2.1 0Zm10.3 0c.6-.6 1.6-.6 2.2 0l4.1 4.2a1.5 1.5 0 1 1-2.1 2l-4.2-4c-.5-.6-.5-1.6 0-2.2ZM152 56.7c.6.6.6 1.5 0 2.1l-4 4.2a1.5 1.5 0 1 1-2.1-2.1l4.1-4.2c.6-.6 1.6-.6 2.1 0Zm27 0c.5-.6 1.5-.6 2 0l4.2 4.2a1.5 1.5 0 1 1-2.1 2l-4.2-4c-.5-.7-.5-1.6 0-2.2ZM143.7 65c.5.6.5 1.5 0 2.1l-4.2 4.2a1.5 1.5 0 1 1-2.1-2.2l4.1-4.1c.6-.6 1.6-.6 2.2 0Zm43.4 0c.6-.6 1.6-.6 2.2 0l4.1 4.1a1.5 1.5 0 1 1-2.1 2.2l-4.2-4.2c-.6-.6-.6-1.5 0-2.1Zm-51.7 8.3c.6.6.6 1.5 0 2.1l-4.2 4.2a1.5 1.5 0 1 1-2.1-2.2l4.1-4.1c.6-.6 1.6-.6 2.2 0Zm60 0c.6-.6 1.6-.6 2.1 0l4.2 4.1a1.5 1.5 0 1 1-2.1 2.2l-4.2-4.2c-.6-.6-.6-1.5 0-2.1Zm-68.3 8.3c.6.6.6 1.5 0 2.1l-4.2 4.1a1.5 1.5 0 0 1-2-2l4-4.2c.6-.6 1.6-.6 2.2 0Zm76.6 0c.6-.6 1.5-.6 2.1 0l4.2 4.1a1.5 1.5 0 1 1-2.1 2.1l-4.2-4.1c-.6-.6-.6-1.5 0-2.1Zm-85 8.3c.7.6.7 1.5 0 2l-4 4.2a1.5 1.5 0 0 1-2.2-2l4.2-4.2c.5-.6 1.5-.6 2 0Zm93.3 0c.6-.6 1.5-.6 2.1 0l4.2 4.1a1.5 1.5 0 0 1-2.2 2.1L212 92c-.6-.6-.6-1.5 0-2.1Zm-101.5 8.3c.6.5.6 1.5 0 2l-4.2 4.2a1.5 1.5 0 0 1-2-2l4-4.2c.7-.6 1.6-.6 2.2 0Zm109.8 0c.6-.6 1.5-.6 2.1 0l4.2 4.1a1.5 1.5 0 1 1-2.2 2.1l-4.1-4.1c-.6-.6-.6-1.6 0-2.1Zm-118.1 8.3c.6.5.6 1.5 0 2l-4.1 4.2a1.5 1.5 0 1 1-2.2-2.1l4.2-4.1c.6-.6 1.5-.6 2.1 0Zm126.4 0c.6-.6 1.5-.6 2.1 0l4.1 4.1a1.5 1.5 0 0 1-2 2.1l-4.2-4.1c-.6-.6-.6-1.6 0-2.1ZM94 114.7c.6.6.6 1.6 0 2.2l-4 4.1a1.5 1.5 0 1 1-2.2-2.1l4.2-4.2c.6-.5 1.5-.5 2.1 0Zm143 0c.6-.5 1.5-.5 2 0l4.2 4.2a1.5 1.5 0 1 1-2 2.1l-4.2-4c-.6-.6-.6-1.6 0-2.2ZM85.7 123c.6.6.6 1.6 0 2.2l-2 2a1.5 1.5 0 0 1-2.2-2l2.1-2.2c.6-.6 1.5-.6 2.1 0Zm159.6 0c.5-.6 1.5-.6 2 0l2.2 2.1a1.5 1.5 0 0 1-2.2 2.1l-2-2c-.6-.6-.6-1.6 0-2.2Zm-168.9 7.8c0-.8.7-1.5 1.5-1.5h3a1.5 1.5 0 0 1 0 3h-3c-.8 0-1.5-.7-1.5-1.5Zm8.8 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.7 0c0-.8.6-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3h-5.8c-.9 0-1.5-.7-1.5-1.5Zm11.6 0c0-.8.7-1.5 1.5-1.5h5.9a1.5 1.5 0 1 1 0 3H110c-.8 0-1.5-.7-1.5-1.5Zm11.7 0c0-.8.7-1.5 1.5-1.5h5.9a1.5 1.5 0 0 1 0 3h-5.9c-.8 0-1.5-.7-1.5-1.5Zm11.7 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 1 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.7 0c0-.8.6-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3h-5.8c-.9 0-1.5-.7-1.5-1.5Zm11.6 0c0-.8.7-1.5 1.5-1.5h5.9a1.5 1.5 0 1 1 0 3h-5.9c-.8 0-1.5-.7-1.5-1.5Zm11.7 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.7 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 1 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.7 0c0-.8.6-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3h-5.8c-.9 0-1.5-.7-1.5-1.5Zm11.6 0c0-.8.7-1.5 1.5-1.5h5.9a1.5 1.5 0 1 1 0 3h-5.9c-.8 0-1.5-.7-1.5-1.5Zm11.7 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.7 0c0-.8.6-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3h-5.8c-.9 0-1.5-.7-1.5-1.5Zm11.6 0c0-.8.7-1.5 1.5-1.5h5.9a1.5 1.5 0 1 1 0 3h-5.9c-.8 0-1.5-.7-1.5-1.5Zm11.7 0c0-.8.7-1.5 1.5-1.5h3a1.5 1.5 0 0 1 0 3h-3c-.8 0-1.5-.7-1.5-1.5Z"
						/>
						<g className="g_a">
							<path
								className="shape"
								d="M56 105a11 11 0 0 0 0 22h11v-11c0-6-5-11-11-11Zm0-3a14 14 0 1 0 0 28h14v-14a14 14 0 0 0-14-14Z"
							/>
							<path d="M54.3 109.2h2.5l4.7 12.8h-2.6l-1.2-3.2h-4.4L52 122h-2.6l4.8-12.8Zm3 7.9-1.8-5.3-1.8 5.3h3.6Z" />
						</g>
						<g className="g_b">
							<path
								className="shape"
								d="M140 16c0 6 5 11 11 11h11V16a11 11 0 0 0-22 0Zm-3 0a14 14 0 0 0 14 14h14V16a14 14 0 1 0-28 0Z"
							/>
							<path d="M156 18.7a3 3 0 0 1-.5 1.8c-.4.5-1 .9-1.6 1.1-.6.3-1.3.4-2 .4h-6.2V9.2h6.9c.6 0 1 .2 1.5.5a3.5 3.5 0 0 1 .9 4.5c-.3.6-.8 1-1.4 1.2a3.2 3.2 0 0 1 2.4 3.3Zm-2.5-.5c0-.3 0-.6-.2-.8a1 1 0 0 0-.5-.6c-.2-.2-.5-.3-.8-.3h-3.8V20h3.7c.3 0 .6 0 .8-.2a1.7 1.7 0 0 0 .8-1.5Zm-5.3-6.9v3.3h3.3l.8-.2c.2-.2.4-.3.5-.6.2-.2.2-.5.2-.9 0-.3 0-.6-.2-.8a1.3 1.3 0 0 0-1.2-.8h-3.4Z" />{" "}
						</g>
						<g className="g_c">
							<path
								className="shape"
								d="M274 105c-6 0-11 5-11 11v11h11a11 11 0 0 0 0-22Zm0-3a14 14 0 0 0-14 14v14h14a14 14 0 1 0 0-28Z"
							/>
							<path d="M267.9 115.5a6.5 6.5 0 0 1 3.6-5.8 6 6 0 0 1 2.7-.6c1.2 0 2.2.3 3 .8a5 5 0 0 1 2 2l-2 1.4a3 3 0 0 0-.8-1.2 3 3 0 0 0-1.1-.6 4 4 0 0 0-1.2-.2 3.4 3.4 0 0 0-2.8 1.4l-.7 1.4a5.5 5.5 0 0 0 0 3.1l.8 1.4 1.2 1c.5.2 1 .3 1.6.3.3 0 .8 0 1.2-.2a2 2 0 0 0 1-.6c.4-.3.7-.7.9-1.1l2 1.1c-.2.7-.6 1.2-1.2 1.7a6.8 6.8 0 0 1-4 1.4c-1 0-1.8-.3-2.5-.7a6.6 6.6 0 0 1-3.3-3.6c-.3-.8-.4-1.6-.4-2.4Z" />
						</g>
					</svg>
				</div>

				<Toggle_measurtement_type force_update={force_update} />
			</div>

			<div className="pusher" style={{ aspectRatio: "33 / 15" }}></div>

			<div className={does_it_work ? "the_measurements pass" : "the_measurements"}>
				<h4>Wall Measurements</h4>

				<div className="measurtement_wrapper">
					{["ab", "bc"].map((key) => {
						return (
							<Render_measurtement
								key={key}
								measurtement_name={key}
								measurtement={eval("measurtement_" + key)}
								set_measurtement={eval("set_measurtement_" + key)}
								force_update={force_update}
							/>
						);
					})}
				</div>

				<h4>Cross Measurements</h4>

				<div className="measurtement_wrapper">
					<Render_measurtement
						key="measurtement_ac"
						measurtement_name="ac"
						measurtement={measurtement_ac}
						set_measurtement={set_measurtement_ac}
						force_update={force_update}
					/>
				</div>

				<Render_status does_it_work={does_it_work} />

				{["ab", "bc", "ac"].map((key) => {
					let new_line = Render_summary({
						the_key: key,
						measurtement_mm: parseInt(eval("measurtement_" + key)),
					});
					if (the_summary == "(empty)") the_summary = new_line;
					else the_summary += new_line;

					// console.log(the_summary);
				})}

				<Render_save_overlay force_update={force_update} the_summary={the_summary} bay_type="One Bend" />
			</div>
		</div>
	);
}
